import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { getAsyncCustomProperties } from 'common/utils/outlookAsyncUtils';
import { SupportedOfficeItem } from 'common/utils/SupportedOfficeItem';
import CONFIG from 'config';
import * as GraphApi from '../utils/graphApi';
import * as OutlookAsyncUtils from '../utils/outlookAsyncUtils';

const TAG = 'ITP3: ';

export async function isItemSavedThroughApi(
  item: SupportedOfficeItem
): Promise<boolean> {
  if (CONFIG.allowToSaveMessageAgain) {
    return false;
  }

  console.log(TAG, 'Checking if item is saved through API', item.subject);

  const properties = await getAsyncCustomProperties(item);
  const isSaved = properties.get(`saved_in_${CONFIG.appPrefix}`);

  console.log(TAG, 'Checking if item is saved through API result', isSaved);

  return isSaved === '1';
}

export async function isItemSavedThroughGraph(message: MicrosoftGraph.Message) {
  if (CONFIG.allowToSaveMessageAgain) {
    return false;
  }

  console.log(TAG, 'Checking if item was saved through Graph API');

  const property = await GraphApi.getExtendedProperty(
    message,
    `saved_in_${CONFIG.appPrefix}`
  );

  console.log(
    TAG,
    'Checking if item was saved through Graph API result',
    property
  );

  return property === '1';
}

export async function markItemAsSavedThroughApi(item: SupportedOfficeItem) {
  if (CONFIG.allowToSaveMessageAgain) {
    return;
  }

  console.log(TAG, 'Marking item as saved through API');

  const properties = await OutlookAsyncUtils.getAsyncCustomProperties(item);
  properties.set(`saved_in_${CONFIG.appPrefix}`, '1');
  await OutlookAsyncUtils.saveAsyncCustomProperties(properties);
}

export async function markItemAsSavedThroughGraph(
  message: MicrosoftGraph.Message
) {
  if (CONFIG.allowToSaveMessageAgain) {
    return;
  }

  console.log(TAG, 'Marking item as saved through Graph API');

  await GraphApi.setExtendedProperty(
    message,
    `saved_in_${CONFIG.appPrefix}`,
    '1'
  );
}
